import { API_URL } from '../Utils/utils';

let active = false;

export function requestBotChallenge() {
  if (active) return Promise.reject(new Error('Please finish the current security check.'));
  const challenge = new URL('/auth/bot-challenge', API_URL);
  if (challenge.protocol !== 'https:') return Promise.reject(new Error('Security checks require a secure connection.'));
  challenge.searchParams.set('parent_origin', window.location.origin);
  active = true;
  return new Promise((resolve, reject) => {
    const previousFocus = document.activeElement;
    const overlay = document.createElement('div');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Security check');
    Object.assign(overlay.style, { position: 'fixed', inset: '0', zIndex: '10000', background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center' });
    const panel = document.createElement('div');
    Object.assign(panel.style, { background: '#fff', padding: '16px', width: 'min(420px, 95vw)' });
    const cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.textContent = 'Cancel security check';
    const frame = document.createElement('iframe');
    frame.title = 'Saleoid security check';
    frame.referrerPolicy = 'no-referrer';
    frame.src = challenge.href;
    Object.assign(frame.style, { border: '0', width: '100%', height: '340px' });
    let timer;
    let finished = false;
    const finish = (token) => {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      window.removeEventListener('message', onMessage);
      window.removeEventListener('keydown', onKey);
      overlay.remove();
      active = false;
      previousFocus?.focus?.();
      if (typeof token === 'string' && token.length > 0 && token.length <= 2048) resolve(token);
      else reject(new Error('Security check cancelled. Please try again when ready.'));
    };
    const onMessage = (event) => {
      if (event.origin === challenge.origin && event.source === frame.contentWindow
        && event.data?.type === 'saleoid.turnstile' && typeof event.data.token === 'string') finish(event.data.token);
    };
    const onKey = (event) => {
      if (event.key === 'Escape') finish();
      if (event.key === 'Tab' && event.target === cancel && event.shiftKey) { event.preventDefault(); frame.focus(); }
    };
    cancel.onclick = () => finish();
    panel.append(cancel, frame);
    overlay.append(panel);
    document.body.append(overlay);
    window.addEventListener('message', onMessage);
    window.addEventListener('keydown', onKey);
    timer = setTimeout(() => finish(), 120000);
    cancel.focus();
  });
}

export function isAuthSendPath(path) {
  return /^\/(?:auth\/(?:phone-otp\/send|phone-identity\/email\/send)|password\/email|email\/resend|api\/mobile\/auth\/(?:forgot-password|signup-email\/send|social-email\/send))$/.test(path);
}
